import { connect } from "react-redux";

import HistoryTable from 'Parts/common/HistoryTable';

const mapStateToProps = state => ({
  logs: state.donation.logs
});

export default connect(mapStateToProps)(HistoryTable);
